export default "__VITE_PUBLIC_ASSET__bb51aed9__"